import {
  MERCADO_PAGO_SUCCESS,
  SET_ACTUAL_SELECCIONADOS,
  SET_NRO_AFILIADO,
  SET_TURNOS_SELECCIONADOS_LABO,
} from "../ActionTypes";

const laboratorio = (state, { payload, type }) => {
  switch (type) {
    case SET_TURNOS_SELECCIONADOS_LABO:
      return {
        ...state,
        turnosSeleccionadosLabo: {
          ...state.turnosSeleccionadosLabo,
          data: payload,
        },
      };
    case SET_ACTUAL_SELECCIONADOS:
      return {
        ...state,
        turnosSeleccionadosLabo: {
          ...state.turnosSeleccionadosLabo,
          actual: payload,
        },
      };
    case MERCADO_PAGO_SUCCESS:
      return {
        ...state,
        turnosSeleccionadosLabo: {
          ...state.turnosSeleccionadosLabo,
          mp: payload,
        },
      };

    case SET_NRO_AFILIADO:
      return {
        ...state,
        turnosSeleccionadosLabo: {
          ...state.turnosSeleccionadosLabo,
          nro_afiliado: payload,
        },
      };

    default:
      return state;
  }
};

export default laboratorio;
